import { Button, DrawerHeader } from '@/design-system';

import { surveyCopy } from '../copy';
import type { BackTarget } from '../hooks/useBackTarget';

export interface SurveyMenuProps {
    /** "NTA 8060 · 24-1183 · BOUWTECHNISCHE KEURING" */
    eyebrow: string;
    address: string;
    answered: number;
    visible: number;
    percentage: number;
    back: BackTarget;
    onBack: () => void;
    /** `null` zodra alles beantwoord is: dan valt er niets meer op te zoeken. */
    onNextIncomplete: (() => void) | null;
    /** "Afronden", of na indienen "Naar rapport" voor kantoor. */
    primaryAction: { label: string; onClick: () => void } | null;
    onClose: () => void;
}

/**
 * Wat niet elke minuut nodig is, een tik achter de drie puntjes in de balk: welke
 * keuring dit is, naar de eerste open vraag springen, afronden en terug. Het menu
 * is een paneel naast de vragen, net als de boom en de bevindingen; het ene
 * paneel sluit het andere.
 */
export function SurveyMenu({
    eyebrow,
    address,
    answered,
    visible,
    percentage,
    back,
    onBack,
    onNextIncomplete,
    primaryAction,
    onClose,
}: SurveyMenuProps) {
    return (
        <div className="flex min-h-full flex-col">
            <DrawerHeader
                eyebrow={eyebrow}
                title={address}
                description={surveyCopy.menu.progress(answered, visible, percentage)}
                onClose={onClose}
                closeLabel={surveyCopy.menu.close}
            />

            <div className="flex flex-col gap-[10px] px-5 py-5">
                {onNextIncomplete ? (
                    <Button variant="outline" size="lg" fullWidth onClick={onNextIncomplete}>
                        {surveyCopy.header.nextIncomplete}
                    </Button>
                ) : (
                    <p className="m-0 text-[13px] leading-[1.5] text-[var(--text-tertiary-safe)]">
                        {surveyCopy.menu.allAnswered}
                    </p>
                )}

                {primaryAction ? (
                    <Button variant="primary" size="lg" fullWidth onClick={primaryAction.onClick}>
                        {primaryAction.label}
                    </Button>
                ) : null}
            </div>

            <div className="mt-auto border-t border-[var(--border-default)] px-5 py-4">
                <Button variant="outline" size="lg" fullWidth icon="back" onClick={onBack}>
                    {back.label}
                </Button>
            </div>
        </div>
    );
}
